import React, { useState, useEffect } from 'react';

const KeyFeatureModal = ({ isOpen, setIsOpen, onSubmit, initialValue}) => {
       const [inputValue, setInputValue] = useState('');

    useEffect(() => {
        setInputValue(initialValue || '');
    }, [initialValue]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(inputValue);
    };

    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Key Feature</h2>
                <form className="oms-modal-form"  onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="featureName" className="oms-form-label">
                            Key Feature Name
                        </label>
                        <input
                            type="text"
                          id="featureName"
                            placeholder="Enter key feature"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            required
                        />
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default KeyFeatureModal;
